<template>
  <v-app-bar app elevate-on-scroll elevation="3" color="grey white--text">
<!--    <v-app-bar-nav-icon @click="$emit('drawerEvent')"></v-app-bar-nav-icon>-->
    <h2 class="white--text">Politik<span class="pink--text">.sms</span></h2>
    <v-spacer/>
    <v-col lg="6" cols="12">
      <v-form>
        <v-text-field
            class="p-0 m-0 mt-6"
            full-width
            dense
            append-icon="mdi-magnify"
            outlined
            rounded
            placeholder="Search"
        />
      </v-form>
    </v-col>
    <v-spacer/>
    <v-menu offset-y>
      <template v-slot:activator="{ attrs, on }">
        <span style="cursor: pointer" v-bind="attrs" v-on="on">
          <v-chip link>
            <v-badge dot bottom color="green" offset-y="10" offset-x="10">
              <v-avatar size="40" class="red">
<!--                <v-img src="https://randomuser.me/api/portraits/women/81.jpg" />-->
              </v-avatar>
            </v-badge>
            <span class="ml-3">Client</span>
          </v-chip>
        </span>
      </template>
      <v-list width="250" class="py-0">
        <v-list-item two-line>
          <v-list-item-avatar class="green">
            <!--            <img src="https://randomuser.me/api/portraits/women/81.jpg" />-->
          </v-list-item-avatar>

          <v-list-item-content>
<!--            <v-list-item-title>{{ $store.state.user.name }}</v-list-item-title>-->
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
        <v-list-item link v-for="(menu, i) in menus" :key="i" @click="$router.push({name:menu.to})">
          <v-list-item-icon>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ menu.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
            color="red"
            class="red--text"
            @click="logout">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "ClientTopbar",
  data() {
    return {
      menus: [
        // {title: "Profile", icon: "mdi-account", to: 'UserChangePassword'},
        // {title: "Change Password", icon: "mdi-key", to: 'UserChangePassword'},
      ],
      items: [
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          title: "Brunch this weekend?",
          subtitle: `<span class="text--primary">Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
        },
        {divider: true, inset: true},
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle: `<span class="text--primary">to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.`,
        },
        {divider: true, inset: true},
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
          title: "Oui oui",
          subtitle:
              '<span class="text--primary">Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?',
        },
        {divider: true, inset: true},
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
          title: "Birthday gift",
          subtitle:
              '<span class="text--primary">Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?',
        },
        {divider: true, inset: true},
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
          title: "Recipe to try",
          subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
        },
      ],
    };
  },
  methods:{
    logout() {
      swal.fire({
        title: 'Log out?',
        text: "You will be logged out and Redirected",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Log me out!'
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem('ptoken');
          localStorage.removeItem('Politik.sms');
          this.$store.dispatch('logout_user');
          toast.fire(
              'Logged out!',
              'Redirecting ....',
              'success'
          );
          this.$router.push('/');
        }
      }).catch(e => {
        console.log(e);
      })
    },
  }
};
</script>

<style scoped></style>
